import { Role } from "../../../Helpers/AuthorizationDataProvider";

export enum TabStatus {
	Error = 'error',
	Loaded = 'loaded',
	Loading = 'loading',
}

export interface Props {
	filters?: string
}

export type Score = 'One' | 'Two' | 'Three' | 'Four' | 'Five';

export type Status = 'Assigned' | 'Unassigned' | 'Accepted' | 'Archived'| 'Rejected';


export interface Rating {
	assignedTo: string
	feedback: string
	ratedAt: string
	score: Score
	status: Status
	user: User
	userRated: User
}

export interface RatingsResponse {
	count: number
	ratings: Rating[]
}

export interface User {
	firstName: string
	imageId: string
	isDeleted: boolean
	lastName: string
	location: string
	role: Role
	userId: string
}

export interface TableData{
	assignedTo: string
	ratedAt: string
	score: Score
	status: Status
	user: User
	userRated: User
}